import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { apiWrapper } from "../../../apis/CommonApi";
import * as fireonApi from '../../../apis/FireOnApi';
import { getDateTime } from "../../../utils/date";
import PageHeader from "../../PageHeader";

export default function FireInspectionScheduleComponent() {
  const { id } = useParams();
  const location = useLocation();
  const { firefightingObject } = location.state;
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingInspectionScheduleList(id);
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    });
  }

  return (
    <section class="mbSection">
      <PageHeader isBlack={false} title="소방설비점검일정" isUseMenu={false} />
      <div class="container">
        <div class="scheduleList">
          {dataSource.length > 0 &&
            dataSource.map((item, index) => (
              <Link
                class="schedule-card"
                to={`/fire-on/fire-inspection-schedule/${id}/detail/`}
                state={{
                  firefightingObject: firefightingObject,
                  scheduleId: item.id,
                }}
              >
                <div class="schedule-card-header">
                  <span class="schedule-title">{item.reason}</span>
                  <div class="schedule-datetime">{`${getDateTime(new Date(item.startDate))} - ${getDateTime(new Date(item.endDate))}`}
                  </div>
                  <i class="x-icon icon-arrow"></i>
                </div>
                <div class="content-info-box">
                  <div class="info">{item.inspector}</div>
                  <span class="divi"></span>
                  <span class="info">{item.contact}</span>
                </div>
              </Link>
            ))}
        </div>
      </div>
      <Link class="floatingBtn" to={`/fire-on/fire-inspection-schedule/${id}/add/`}>
        점검일정 등록
        <i class="x-icon icon-add"></i>
      </Link>
    </section>
  );
}
